import React from "react";

const Footer = () => {
  return (
    <div className="spacetop fixed bottom-0 py-4 bg-[#fffcfb] w-full mb-0 ">
      <div className="desfoote">
        <p>© 2025. FastBetter. All rights reserved V 1.0.0 </p>
      </div>
    </div>
  );
};
export default Footer;
